import {environment} from '../../../environments/environment';
import {environmentMockServer} from '../environment';

export const BaseURL = environment.BASE_URL;
export const BaseURLMock = environmentMockServer.BASE_URL;
export const BaseURLUser = environment.BASE_URL_USER;
export const BaseURLGroup = environment.BASE_URL_GROUP;
export const BaseURLLibrary = environment.BASE_URL_LIBRARY;
export const BaseURLLink = environment.BASE_URL_LINK;
